import { TimeUnit } from '@mews/enums';
import { NoItems, SummaryRowBody } from '../../SummaryRow';
import TimeUnitCountLabel from './TimeUnitCountLabel';

interface TimeUnitCountBodyProps {
    timeUnitCount: number;
    timeUnit: TimeUnit;
    startUtc?: string;
    endUtc?: string;
}

const TimeUnitCountBody = ({ timeUnit, timeUnitCount, startUtc, endUtc }: TimeUnitCountBodyProps) => {
    if (!timeUnitCount) {
        return <NoItems />;
    }

    return (
        <SummaryRowBody
            count={timeUnitCount}
            text={<TimeUnitCountLabel timeUnit={timeUnit} startUtc={startUtc} endUtc={endUtc} />}
            data-test-timeUnit={timeUnit}
        />
    );
};

export default TimeUnitCountBody;
